import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-splash-header',
    templateUrl: './splash-header.component.html',
    styleUrls: ['./splash-header.component.scss'],
    standalone: false
})
export class SplashHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
